import styled from "styled-components";
import { FormWrapper, OrangeAccentCard } from "../../styles/shared";

export const SignInWrapper = styled.div`
  background: #0a0e27;
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  width: 100%;
  max-width: 100%;
  
  @media (min-width: 576px) {
    padding: 1.5rem;
  }
  
  @media (min-width: 768px) {
    padding: 2rem;
  }
`;

export const LogoContainer = styled.div`
  position: relative;
  z-index: 1;
  margin-bottom: 2rem;
  text-align: center;
  
  img {
    filter: drop-shadow(0 0 15px rgba(242, 146, 5, 0.5));
    transition: transform 0.3s ease;
    
    &:hover {
      transform: scale(1.05);
    }
  }
`;

export const LoginCard = styled(OrangeAccentCard)`
  position: relative;
  z-index: 1;
  max-width: 90% !important;
  width: 100% !important;
  margin: 0 auto;
  flex-shrink: 0;
  
  @media (min-width: 576px) {
    max-width: 400px !important;
  }
  
  @media (min-width: 768px) {
    max-width: 450px !important;
  }
  
  @media (min-width: 992px) {
    max-width: 500px !important;
  }
`;

export const CardHeader = styled.div`
  text-align: center;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 24px;
  
  @media (min-width: 768px) {
    padding-bottom: 20px;
    margin-bottom: 28px;
  }
  
  @media (min-width: 992px) {
    padding-bottom: 24px;
    margin-bottom: 32px;
  }
  
  h1 {
    color: #ffffff;
    font-size: 22px;
    font-weight: 700;
    margin: 0;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    
    @media (min-width: 576px) {
      font-size: 24px;
    }
    
    @media (min-width: 768px) {
      font-size: 26px;
    }
    
    @media (min-width: 992px) {
      font-size: 28px;
    }
    
    i {
      color: #f29205;
      margin-right: 8px;
      text-shadow: 0 0 10px rgba(242, 146, 5, 0.5);
      font-size: 20px;
      
      @media (min-width: 576px) {
        margin-right: 10px;
        font-size: 22px;
      }
      
      @media (min-width: 768px) {
        margin-right: 12px;
        font-size: 24px;
      }
    }
  }
`;

export const CardBody = styled.div`
  padding: 0;
`;

export const FooterText = styled.p`
  text-align: center;
  color: #b0b0b0;
  margin-top: 24px;
  font-size: 14px;
  
  @media (min-width: 768px) {
    margin-top: 28px;
    font-size: 15px;
  }
  
  @media (min-width: 992px) {
    margin-top: 32px;
    font-size: 16px;
  }
  
  a {
    color: #f29205;
    font-weight: 700;
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: inherit;
    
    &:hover {
      color: #ff6b35;
      text-shadow: 0 0 10px rgba(242, 146, 5, 0.5);
      text-decoration: underline;
    }
  }
`;

export const CopyrightContainer = styled.div`
  position: relative;
  z-index: 1;
  margin-top: 1.5rem;
  text-align: center;
  color: #b0b0b0;
  font-size: 12px;
  
  @media (min-width: 768px) {
    margin-top: 1.75rem;
    font-size: 13px;
  }
  
  @media (min-width: 992px) {
    margin-top: 2rem;
    font-size: 14px;
  }
  
  * {
    font-size: inherit !important;
  }
`;

// FormWrapper com estilos responsivos para botão (mesmo padrão da dashboard)
export const StyledFormWrapper = styled(FormWrapper)`
  @media (max-width: 767px) {
    .mobile-button,
    button.mobile-button {
      width: 100% !important;
      justify-content: center !important;
      padding: 10px 20px !important;
      font-size: 14px !important;
      height: 48px !important;
      min-height: 48px !important;
      max-height: 48px !important;
      display: flex !important;
      align-items: center !important;
      
      & > span {
        font-size: 14px !important;
      }
      
      svg {
        width: 18px !important;
        height: 18px !important;
      }
    }
  }
`;

// Exportando FormWrapper compartilhado
export { FormWrapper };
